import { useNavigate } from 'react-router-dom'
import { t } from 'i18next'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <div className='w-full h-full flex-column justify-center items-center'>
      <div className='flex-column justify-center gap-[20px] h-full w-full items-center box-content'>
        <div>{t('global.page.not.found')}</div>
        <button onClick={() => navigate('/')}>
          {t('global.go.back.to.dashboard')}
        </button>
      </div>
    </div>
  )
}

export default NotFoundPage
